import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import PropTypes from 'prop-types';
import { removeManualAssignment } from '../../../../actions/manual-assignments';
import MLButton from '../../../../components/MLButton';
import MLIcon from '../../../../components/MLIcon';
import s from './ManualAssignmentActions.module.css';
import ManualAssignments from '../../../modals/ManualAssignments/ManualAssignments';
import MLDialog from '../../../../components/MLDialog/MLDialog';
import MLTooltip from '../../../MLTooltip';

class ManualAssignmentActions extends Component {
  static propTypes = {
    assignment: PropTypes.object,
    deleteManualAssignment: PropTypes.func,
    showAsLabel: PropTypes.bool,
    disableActions: PropTypes.bool,
    tooltipContent: PropTypes.string,
  };

  static defaultProps = {
    showAsLabel: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
      anchorEl: null,
      showCreateModal: false,
      showRemoveColumnWarning: false,
    };
  }

  render() {
    const { showMenu, anchorEl, showCreateModal, showRemoveColumnWarning } =
      this.state;
    const {
      assignment,
      deleteManualAssignment,
      disableActions,
      showAsLabel,
      tooltipContent,
    } = this.props;

    return (
      <div className={s.dropDownMenuWrapper}>
        {
          <MLDialog
            show={showRemoveColumnWarning}
            title="Remove Column"
            actions={[
              <MLButton
                btnType="secondaryRed"
                type="submit"
                onClick={async () => {
                  await deleteManualAssignment(assignment);
                  this.setState({ showRemoveColumnWarning: false });
                }}
                key={0}
              >
                Yes, Remove
              </MLButton>,
              <MLButton
                btnType="secondary"
                testId="cancel_button"
                onClick={() => {
                  this.setState({ showRemoveColumnWarning: false });
                }}
                key={1}
              >
                Cancel
              </MLButton>,
            ]}
            onClose={() => {
              this.setState({ showRemoveColumnWarning: false });
            }}
          >
            Are you sure you would like to remove the column &quot;
            {assignment.name}&quot; <br />
            and grades? This action cannot be undone.
          </MLDialog>
        }
        {showCreateModal && (
          <ManualAssignments
            assignment={assignment}
            showModal={showCreateModal}
            onClose={() => {
              this.setState({ showCreateModal: false });
            }}
          />
        )}

        {showAsLabel && (
          <MLTooltip placement="top" content={tooltipContent}>
            <div className={s.triggerContainer}>
              <span
                className={s.link}
                onClick={(event) => {
                  this.setState({
                    showMenu: true,
                    anchorEl: event.currentTarget,
                  });
                }}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    this.setState({
                      showMenu: true,
                      anchorEl: event.currentTarget,
                    });
                  }
                }}
                role="button"
                tabIndex={0}
                aria-haspopup="true"
                aria-expanded={showMenu}
              >
                {assignment.name}
              </span>
            </div>
          </MLTooltip>
        )}

        {/* by default this element should present the icon to show the actions */}
        {!showAsLabel && (
          <MLButton
            btnType="secondary"
            className={s.dropDownMenu}
            onClick={(event) => {
              this.setState({
                showMenu: true,
                anchorEl: event.currentTarget,
              });
            }}
          >
            <MLIcon className={s.headerBtnIcon} type="caret_down" />
          </MLButton>
        )}

        {showMenu && (
          <Popover
            open={showMenu}
            anchorEl={anchorEl}
            onClose={() => {
              this.setState({ showMenu: false });
            }}
          >
            <MenuList>
              <MenuItem
                disabled={disableActions}
                onClick={() => {
                  this.setState({ showCreateModal: true, showMenu: false });
                }}
              >
                <MLIcon
                  type="edit"
                  className={classnames(s.menuItemIcon, {
                    [s.menuItemIconDisabled]: disableActions,
                  })}
                />
                <span className={s.menuItemText}>Edit Assignment Details</span>
              </MenuItem>
              <MenuItem
                disabled={disableActions}
                onClick={() => {
                  this.setState({
                    showRemoveColumnWarning: true,
                    showMenu: false,
                  });
                }}
              >
                <MLIcon
                  type="trash"
                  className={classnames(s.menuItemIcon, {
                    [s.menuItemIconDisabled]: disableActions,
                  })}
                />
                <span className={s.menuItemText}>Remove Column</span>
              </MenuItem>
            </MenuList>
          </Popover>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  deleteManualAssignment: (assignment) =>
    dispatch(removeManualAssignment(assignment)),
});

export default connect(null, mapDispatchToProps)(ManualAssignmentActions);
